export type LanguageType = 'en' | 'es'

export interface LanguageState {
    language: LanguageType;
}

const lang = localStorage.getItem('TRUORA_LANGUAGE')
const langSetted : LanguageType = lang && ['en', 'es'].includes(lang) ? lang as LanguageType : 'en'

export const defaultState: LanguageState = {
  language: langSetted
}

export default {
  ...defaultState
}
